export default {
    black: '#2F313F',
    labelGrey: '#74767D',

    white: '#FFFFFF',
    brightGray: '#F5F4F6',
    greyHover: '#EBEAEC',
    menuSeparator: '#E3E0E5',

    darkWhite: '#FFFFFF',
    darkBlack: '#1A1B20',

    blue: '#1542C3',
    lightBlue: '#4570EA',
    variantBlue: '#DAE2FB',
    header: '#4570EA',
    red: '#DC0000',
    lightRed: '#C3151529',
    orange: '#F1A208',
    green: '#009229',
    lightGreen: '#31BF7B29',

    // ??
    fillGrey: '#D1D1D1',
    lightGrey: '#F4F4F6',
    lightBlack: '#8C8E97',
    darkerBrightGray: '#F0EFF2',
    lightGray: '#EFEFEF',
    iconGrey: '#BFC0CB',
    gold: '#FFC657', // Self-Service
    admin: '#222958',
};

export const darkColors = {
    black: '#F2F3F5',
    labelGrey: '#C1C2C7',

    white: '#353638',
    brightGray: '#46474A',
    greyHover: '#696A6E',
    menuSeparator: '#57585C',

    darkWhite: '#FFFFFF',
    darkBlack: '#1A1B20',

    blue: '#4468CF',
    lightBlue: '#11359C',
    variantBlue: '#242526',
    header: '#242526',
    red: '#E24646',
    lightRed: '#E2464629',
    orange: '#F9AC76',
    green: '#84DB73',
    lightGreen: '#84DB7329',

    // ??
    fillGrey: '#4B5563',
    lightGrey: '#374151',
    lightBlack: '#9CA3AF',
    darkerBrightGray: '#111827',
    lightGray: '#374151',
    iconGrey: '#6B7280',
    gold: '#FCD34D',
    admin: '#242526',
};

// Baked into the drop-off SVGs (`dropoff`, `dropoff_pin`) in both themes. Dark mode makes SvgIcon
// rewrite `path { stroke: inherit }`, so those icons have to be handed this colour explicitly or the
// pin outline resolves to the near-white default icon stroke. Keep in sync with the CDN assets.
export const dropOffGreen = '#31BF7B';
